<template>
    <div>
        <loading-custom :loading="loading" />
        <category-create-component :shop="shop" @onUpdate="onStore($event)" />
        <div class="table-responsive">
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th scope="cols" width="5%" class="text-right">
                            ลำดับ
                        </th>
                        <th scope="cols" width="15%" class="text-center">
                            ไอคอน
                        </th>
                        <th scope="cols" width="65%">ชื่อหมวดหมู่</th>
                        <th scope="cols" width="10%">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            tableData
                                ? tableData.length === 0
                                : tableData
                        "
                    >
                        <td class="text-center" colspan="4">
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr
                        v-for="(item, index) in tableData"
                        :key="index"
                        class="my-4"
                    >
                        <th class="text-right align-middle">
                            <!-- ลำดับ -->
                            {{ index + 1 }}
                        </th>
                        <td class="text-center align-middle">
                            <!-- ไอคอน -->
                            <i :class="`fa ${item.icon} fa-4x`"></i>
                        </td>
                        <td class="align-middle">
                            <!-- ชื่อหมวดหมู่ -->
                            {{ item.title }}
                        </td>
                        <td class="align-middle tw-justify-content-start">
                            <div class="d-flex">
                                <!-- Action -->
                                <category-edit-component
                                    :shop="shop"
                                    :category="item"
                                    @onUpdate="onUpdate($event)"
                                ></category-edit-component>
                                <category-delete-component
                                    :shop="shop"
                                    :category="item"
                                    @onUpdate="onUpdate($event)"
                                ></category-delete-component>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="tw-flex tw-mt-5  tw-justify-center lg:tw-justify-end">
                <paginate
                    :data="tableData"
                    :page="page"
                    @onPage="onPage($event)"
                    v-show="tableData.total > 0"
                ></paginate>
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">
import paginate from "../../helper/Paginate.vue";

export default {
    props: { shop: String },
    components: {
        paginate
    },
    data() {
        return {
            tableData: [],
            page: 1,
            loading: false
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            await axios.get(`/ajax/s/${this.shop}/categories?page=${this.page}`).then(res => {
                this.tableData = res.data.categories;
            });
        },
        onUpdate(event) {
            if (event == "success") {
                this.getData();
            }
        },
        onStore(event) {
            if (event == "success") {
                this.getData();
            }
        },
        onPage(page) {
            this.page = page;
            this.getData();
        },
    }
};
</script>
<style lang="scss" scoped>
.table-image {
    width: 60px;
    // max-width: 200px;
}
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
